var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-col",
        {
          staticClass: "pt-0 pl-0",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c("gg-text-field", {
            attrs: {
              outlined: "",
              "append-icon": "mdi-magnify",
              "single-line": "",
              "hide-details": ""
            },
            model: {
              value: _vm.search,
              callback: function callback($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          search: _vm.search,
          loading: !_vm.cronJobsLoaded,
          items: _vm.items
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      bottom: "",
                      "offset-y": "",
                      "min-width": "180"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function fn(_ref2) {
                            var on = _ref2.on,
                              attrs = _ref2.attrs
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(_vm._b({}, "gg-btn", attrs, false), on),
                                [
                                  _vm._v(" Manage "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        right: ""
                                      }
                                    },
                                    [_vm._v("mdi-chevron-down")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openEditModal(item)
                              }
                            }
                          },
                          [_c("v-list-item-title", [_vm._v(" Edit ")])],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openDeleteModal({
                                  count: item.count
                                })
                              }
                            }
                          },
                          [_c("v-list-item-title", [_vm._v("Delete")])],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm.selectedCronJob
        ? _c("delete-cron-job-dialog", {
            attrs: {
              opened: _vm.deleteModal,
              job: _vm.selectedCronJob
            },
            on: {
              close: _vm.closeDeleteModal,
              "job-deleted": _vm.reload
            }
          })
        : _vm._e(),
      _vm.selectedCronJob
        ? _c("edit-cron-job-dialog", {
            attrs: {
              opened: _vm.editModal,
              job: _vm.selectedCronJob
            },
            on: {
              close: _vm.closeEditModal,
              "job-updated": _vm.reload
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }